<template>
  <div>
    <p class="mb-0"><span class="badge badge-success">З</span>: <strong>{{
        Math.round((stats[3]?.total ?? 0) * 10) / 10
      }}</strong>
      (<strong>{{ getTotalPrice(stats[3]?.price) }}</strong>) <strong v-if="allShift">{{ getPercent(3) }}%</strong></p>
    <p class="mb-0"><span class="badge badge-info">О</span>: <strong>{{
        Math.round((stats[1]?.total ?? 0) * 10) / 10
      }}</strong>
      (<strong>{{ getTotalPrice(stats[1]?.price) }}</strong>) <strong v-if="allShift">{{ getPercent(1) }}%</strong></p>
    <p class="mb-0"><span class="badge badge-warning">М</span>: <strong>{{
        Math.round((stats[-2]?.total ?? 0) * 10) / 10
      }}</strong>
      (<strong>{{ getTotalPrice(stats[-2]?.price) }}</strong>) <strong v-if="allShift">{{ getPercent(-2) }}%</strong>
    </p>
    <p class="mb-0"><span class="badge badge-warning">К</span>: <strong>{{
        Math.round((stats[-3]?.total ?? 0) * 10) / 10
      }}</strong>
      (<strong>{{ getTotalPrice(stats[-3]?.price) }}</strong>) <strong v-if="allShift">{{ getPercent(-3) }}%</strong>
    </p>
  </div>
</template>

<script>

export default {
  props: ['stats', 'allShift'],
  methods: {
    getPercent(status) {
      return Math.round((this.stats[status]?.total ?? 0) * 100 / (this.allShift[status]?.total ?? 1));
    },
    getTotalPrice(price) {
      return (Math.round((price ?? 0) / 100) / 10) + 'k';
    }
  }
}

</script>
